/**
 * [CUSTOM FILE] — not part of Stretch base theme
 * collection-loading-state.js
 * ----------------------------
 * Dims the collection grid while a facet update is in flight. Stretch's
 * own facets-listeners.js already dispatches theme:loading:start/end
 * (bubbling on document.documentElement) for every native filter, sort,
 * and pagination change - nothing previously reacted to them beyond
 * loading-bar.js's 2-3px bar pinned to the very top of the viewport, easy
 * to miss and visually static for most of the wait. See the CSS rule this
 * toggles in cs-custom.css.liquid (section 10).
 *
 * Deliberately its own file, not folded into color-filter-bar.js: these
 * events fire for every native facet interaction (size, category, price,
 * sort, pagination), not just the color filter bar, so this needs to run
 * on every collection page regardless of whether that component renders.
 * Loaded from collection-toolbar.liquid, present on every collection page.
 */
(() => {
  if (window._csGridLoadingWatched) return;
  window._csGridLoadingWatched = true;

  const GRID_SELECTOR = '.collection product-list, .collection .product-list';

  // Safety net: Stretch's own facet:update listener silently swallows a
  // genuine fetch failure (an empty catch, distinct from an aborted
  // request when a newer update supersedes this one) without ever
  // dispatching theme:loading:end - which would otherwise leave the grid
  // dimmed indefinitely.
  const STUCK_TIMEOUT_MS = 15000;
  let stuckTimer = null;

  const setLoading = (loading) => {
    document.querySelectorAll(GRID_SELECTOR).forEach(grid => {
      grid.classList.toggle('is-loading', loading);
    });
  };

  document.documentElement.addEventListener('theme:loading:start', () => {
    setLoading(true);
    clearTimeout(stuckTimer);
    stuckTimer = setTimeout(() => setLoading(false), STUCK_TIMEOUT_MS);
  });

  document.documentElement.addEventListener('theme:loading:end', () => {
    clearTimeout(stuckTimer);
    setLoading(false);
  });
})();
